<template>
    <div class="panel-group">
        <div style="position:relative;background:white;width:300px;height:400px;margin:0 auto;border-radius:10px;padding:10px;margin-top:20px;">

            <div>
            <div class="col-xs-4">
                <h3>Forgot:</h3>
            </div>
            <div class="col-xs-8">
            </div>
            </div>

            <div class="col-xs-12">
                <input v-model="registerInfo.email" type="text" placeholder="Login Email" class="form-control" />
            </div>
          
            <div>
                <div class="col-xs-12">
                    <span class="btn btn-default" @click="goLogin">Login</span>
                    <span style="float:right;" class="btn btn-default" @click="resetAccount">Reset</span>
                </div>
            </div>
            <div v-if="msg!==null" class="col-xs-12" style="color:red;text-align:center;">
                <h4>{{msg.title}}</h4>
                <div>{{msg.message}}</div>
            </div>
            

        </div>
    </div>
</template>
<script>
   
    export default {
        //props: ["apiClient"],
        computed: {
            apiClient: function () {
                return this.mxnAgxApi.forgotLoginApiClient;
            }
        },
        data: function () {
            return {
                registerInfo: { name: null, password: null },
                msg: null
            }
        },
        methods: {
            goLogin: function() {
                this.apiClient.getProfilePrms();
            },
            resetAccount: function () {
                var that = this;
                this.msg = null;
                this.apiClient.forgotLoginPrms(this.registerInfo)
                    .done(function (ret) {
                        that.msg = ret;
                    });
            }
        },
        mounted: function () {
        }
    }
</script>